<template>
  <div id="feedback" v-if="show">
    <template v-if="submitted">
      <p>Thank you for your feedback!</p>
    </template>
    <template v-else>
      <div class="score">
        <p>
          <slot></slot>
        </p>
        <div class="thumbs">
          <span @click="upVote">👍</span>
          <span @click="downVote" :class="{ selected: score == 0 }">👎</span>
        </div>
      </div>
      <div class="submit-comment" v-show="score == 0">
        <textarea ref="comment" v-model="comment" placeholder="Add a comment..."></textarea>
        <button class="submit" @click="submit">Submit</button>
      </div>
    </template>
  </div>
</template>

<script>

export default {
  props: {
    show: { type: Boolean, default: false },
  },
  emits: ['submit'],
  data: function(){
    return {
      comment: "",
      score: null,
      submitted: false
    }
  },
  methods: {
    upVote: function(){
      this.score = 1;
      this.submit();
    },
    downVote: function(){
      this.score = 0
    },
    submit: function(){
      if(this.score == null && this.comment == "") { return; }

      this.submitted = true;
      this.$emit('submit', { score: this.score, comment: this.comment })
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '@/packs/colors.scss';

  #feedback {
    background: $white-three;
    padding: 15px;
    border-radius: 6px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .5);
  }

  p {
    font-weight: 700;
    margin: 0;
  }

  .score {
    display: flex;
    align-items: center;

    .thumbs {
      margin-left: 20px;

      span {
        padding: 5px;
        margin: 5px;
        border-radius: 6px;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12);
        border: solid 1px $manatee;
        background-color: $white;
        cursor: pointer;

        &.selected {
          background: $dark-gray;
        }
      }
    }
  }

  .submit-comment {
    margin-top: 20px;

    textarea {
      width: 100%;
      height: 85px;
      margin-bottom: 10px;
      border-color: $silver-chalice;
      border-radius: 5px;
    }

    .submit {
      background: $bright-blue;
      outline: none;
      border: none;
      border-radius: 5px;
      color: $white;
      padding: 4px 24px;
      background: $bright-blue;
      float: right;
    }
  }

  @media (max-width: 767px) {
    #feedback {
      padding: 10px;
    }

    p {
      font-size: .7rem;
    }

    .score .thumbs {
      margin-left: 10px;

      span {
        padding: 3px;
        margin: 3px;
        font-size: .7rem;
      }
    }
  }
</style>